<template>
    <div class="branding" :style="styles">
        <logo-n />
        <heading :level="3" v-html="category.label" />
    </div>
</template>

<script>
import Heading from 'gvue/src/core/Heading'
import LogoN from '@/components/common/LogoN'

export default {
    name: 'SectionBranding',
    components: {
        Heading,
        LogoN
    },
    props: {
        category: {
            type: Object,
            required: true
        }
    },
    computed: {
        styles() {
            return {
                borderColor: this.category.color
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables

.branding
    position: relative
    padding: ($gap * 1.5) ($gap * 1.25)

    &::before
        +fit
        z-index: -1
        content: ''
        background-color: $color_background

.g_h3
    margin: 0
    max-width: 10em
    font-weight: 500

+mobile
    .logo
        display: none

    .branding
        border-left: 4px solid

+desktop
    .branding
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center
        min-height: ($gap * 25)

        &::before
            left: auto
            width: calc(50vw - 68px)

    .g_h3
        position: absolute
        left: 50%
        bottom: ($gap * 1.25)
        transform: translateX(-50%)
        text-align: center
</style>
